// Some top-level menus (e.g. the receptionist's "Visitor Management") carry no
// urlPath from the backend, so login would land on an empty page. Map them by
// menu name to the screen they should open.
export const TOP_LEVEL_PATH_FALLBACKS: Record<string, string> = {
    'visitor management': '/visitormanagement',
}

// Same "?mc=<menuCode>" suffix the backend puts on every other menu's urlPath.
export const menuFallbackFor = (menu: {
    menuName?: string
    menuCode?: string | number
}): string => {
    const path = TOP_LEVEL_PATH_FALLBACKS[menu?.menuName?.trim().toLowerCase() ?? '']
    return path ? `${path}?mc=${menu.menuCode}` : ''
}

// The receptionist login has a single top-level "Visitor Management" menu
// (no urlPath, no sub-menu).
export const isReceptionistMenu = (): boolean => {
    try {
        const menu = JSON.parse(localStorage.getItem('userMenuList') ?? '[]')
        return (
            Array.isArray(menu) &&
            menu.some(
                (m: {
                    menuName?: string
                    urlPath?: string | null
                    menuList?: unknown[] | null
                }) =>
                    m.menuName?.trim().toLowerCase() === 'visitor management' &&
                    !m.urlPath &&
                    !m.menuList,
            )
        )
    } catch {
        return false
    }
}

export const fallbackMenuPath = (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    menuList: any[] | null | undefined,
): string => {
    for (const main of menuList ?? []) {
        const path = menuFallbackFor(main)
        if (path && !main.urlPath && !main.menuList) return path
    }
    return ''
}
